import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Cookies from 'js-cookie';

import elementEnUSLocale from 'element-ui/lib/locale/lang/en';
import elementZhCNLocale from 'element-ui/lib/locale/lang/zh-CN';
import elementZhTWLocale from 'element-ui/lib/locale/lang/zh-TW';

import zhCNLocale from './zh-CN';
import zhCNCompLocale from './components_zh-CN';
import zhCNPageLocale from './page_zh-CN';

import zhTWLocale from './zh-TW';

import enUSLocale from './en-US';
import enUSCompLocale from './components_en-US';
import enUSPageLocale from './page_en-US';



import dictionary from './dictionary'

Vue.use(VueI18n);

const messages = {
  enUS: {
    ...enUSLocale,
    ...enUSCompLocale,
    ...enUSPageLocale,
    ...elementEnUSLocale
  },
  zhCN: {
    ...zhCNLocale,
    ...zhCNCompLocale,
    ...zhCNPageLocale,
    ...elementZhCNLocale
  },
  zhTW: {
    ...zhTWLocale,
    ...elementZhTWLocale
  }
};

const missingHandler = function (locale, key) {
    if(key){
      if( key.indexOf(".") > -1){
          let newKey = key.substring(key.lastIndexOf(".") + 1);
          let newVal = dictionary[locale][newKey];
          return newVal || newKey;
      }else{
          let newVal = dictionary[locale][key];
          return newVal || key;
      }
    }
    return key;
};


let defaultLang = navigator.language.replace('-','');
let hasDefault = ['zhCN','enUS'].indexOf(defaultLang)>-1;
const i18n = new VueI18n({
  locale: Cookies.get('language') || (hasDefault?defaultLang:'zhCN'), // set locale
  missing:missingHandler,
  silentTranslationWarn:false,
  silentFallbackWarn:false,
  formatFallbackMessages:false,
  messages

});

export default i18n



// WEBPACK FOOTER //
// /home/jenkins/.jenkins/workspace/tms-saas/code/tms-front/test/tms-front/src/locale/index.js